import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";


export interface IShopState {
  shop: {
    id: number;
    type: string;
    industry_id: number;
    kv_industry_id: number;
    industry_name: string;
    active_package_id: number;
    active_package_name: string;
    remaining_day: number;
    branch_count: number;
    started_at: string;
    expire_at: string;
    isShopEndOfSubscription: boolean;
    onboarding_at: string;
  };
  isOpenNotiEndSubscription: boolean;
  isShopInactive: boolean;
  isShowAlertEndSubscription: boolean;
  isShopUpgradePackageSuccess: boolean;
}

export interface OnboardingType {
  popup: boolean;
  video_page_builder: boolean;
  video_merchandise_and_price: boolean;
  video_theme_store: boolean;
  video_product: boolean;
  video_product_category: boolean;
  video_hot_category: boolean;
  feature_release: boolean;
}

const initialState: IShopState = {} as IShopState;

export const ShopSLice = createSlice({
  name: "shop",
  initialState,
  reducers: {
    setShopInfo: (state, action: PayloadAction<IShopState>) => {
      state.shop = Object.assign({}, action.payload.shop);
    },
    setIsOpenNotiEndSubscription: (
      state,
      action: PayloadAction<{ value: boolean }>
    ) => {
      state.isOpenNotiEndSubscription = action.payload.value;
    },
    setIsShopInactive: (state, action: PayloadAction<{ value: boolean }>) => {
      state.isShopInactive = action.payload.value;
    },
    setIsShowAlertEndSubscription: (
      state,
      action: PayloadAction<{ value: boolean }>
    ) => {
      state.isShowAlertEndSubscription = action.payload.value;
    },
    setIsShopUpgradePackageSucce: (
      state,
      action: PayloadAction<{ value: boolean }>
    ) => {
      state.isShopUpgradePackageSuccess = action.payload.value;
    },
  },
});

export const {
  setShopInfo,
  setIsOpenNotiEndSubscription,
  setIsShopInactive,
  setIsShowAlertEndSubscription,
  setIsShopUpgradePackageSucce,
} = ShopSLice.actions;
export const ShopInformation = (state: RootState) => state.shop;

export default ShopSLice.reducer;
